<div class="flex flex-col flex-auto items-center sm:justify-center min-w-0">
    <div class="w-full sm:w-auto py-8 px-4 sm:p-12 sm:rounded-2xl sm:shadow sm:bg-card">
        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
            <!-- Logo -->
            <div class="flex justify-center">
                <div>
                    <img class="dark:hidden" src="assets/images/logo/logo-text.svg" alt="Logo">
                    <img class="hidden dark:flex" src="assets/images/logo/logo-text-on-dark.svg" alt="Logo">
                </div>
            </div>

            <!-- Title -->
            <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">
                {{ 'Multi-Factor Authentication Reset' | transloco }}
            </div>

            <!-- Content -->
            <div class="mt-6 text-sm text-secondary">
                <fuse-alert *ngIf="showAlert" class="mt-8 " [appearance]="'outline'" [showIcon]="false" [type]="alert?.type">
                    {{ alert?.message }}
                </fuse-alert>

                <div class="mfa-step-container">
                    <p class="mb-4 mt-4 text-black text-base">
                        {{ 'If you no longer have access to your device, you can request to disable Multi-factor Authentication on your account.' | transloco }}
                    </p>
                    <p class="mb-6 text-black text-base">
                        {{ 'Click the button below to disable Multi-factor Authentication for your account.' | transloco }}
                    </p>
                </div>

                <button mat-flat-button class="fuse-mat-button-large w-full mt-4 font-semibold" color="primary" type="button" (click)="onConfirmReset()" [disabled]="isSubmitting || actionCompleted">
                    <span *ngIf="!isSubmitting">{{ 'Reset MFA' | transloco }}</span>
                    <mat-progress-spinner *ngIf="isSubmitting" [diameter]="24" mode="indeterminate" class="ml-2"></mat-progress-spinner>
                </button>
            </div>
        </div>
    </div>
</div>